import React, { useState } from 'react';

import { Alert, Box, Button, Stack } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useConsolidationSummaryStudents } from '@/features/dashboard/api/getConsolidationSummaryStudents';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import { TitlePages } from '@/components/Base/TitlePage';
import Thermometer from '@/components/Base/Thermometer';
import { useTermometroFinanceiroDetalhes } from '@/features/termometro/getTermometroFinanceiroDetalhes';
import KpiComponentGreen from '@/components/Base/KpiComponentGreen';

export const TermometroRaiox = () => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const location = useLocation();
  const { id, name } = location.state || {};

  const { data: summary, isError, refetch, isFetching, isFetched } = useTermometroFinanceiroDetalhes(id);
  const {
    data,
    isFetching: isFetchingStudents,
    isFetched: isFetchedStudents,
  } = useConsolidationSummaryStudents({ year: selectedYear, month: selectedMonth });

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)} />
          <TitlePages title={'Raio-X por aluno'} />
        </Stack>

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            onClick={() => navigate('/inadimplencia-recomendacoes-alunos', { state: { id, name } })}
            variant="contained"
            sx={{
              fontWeight: '700',
              borderRadius: '24px',
              fontSize: '14px',
              height: '37px',
              color: '#fff',
              textTransform: 'capitalize',
              backgroundColor: '#15AB51',
            }}
          >
            Visualizar recomendação
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponentGreen
                title={'Score médio'}
                value={String(summary.medium_score).replace('.', ',')}
                // value={'9.5'}
              />
              <KpiComponent title={'Situação'} value={summary.is_active ? 'Ativo' : 'Inativo'} />
              <KpiComponent
                title={'Score Frequência'}
                value={`${summary.discount}%`}
                // value={'7'}
              />
              <KpiComponent
                title={'Score financeiro'}
                value={`${summary.discount}`}
                // value={'8'}
              />

              <KpiComponent
                title={'Ìndice de faltas'}
                value={`${summary.discount}`}
                // value={'5%'}
              />
            </Stack>
          </Stack>
        )}
        {isFetching && !summary && <LoadingSummary />}
        <Box>
          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer title={'Termômetro financeiro'} score={summary?.financial_score || 0}/>
          </Box>

          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer title={'Termômetro pedagógico'} score={summary?.pedagogic_score || 0}/>
          </Box>

          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer title={'Termômetro Frequência'} score={summary?.frequency_score || 0}/>
          </Box>
        </Box>
      </Box>
    </>
  );
};
